const dev = {
  NEO_KEY: "20E38214tC181205",
  // SERVICE_URL: "http://uat.nfcbankonline.com:8000/apigateway",
  SERVICE_URL: "https://www.nfcbankonline.com/apigateway",
  GOOGLE_MAPS_API_KEY: "AIzaSyD94dYAJU4hkOyMi3mz6QGWxUsqkAx-9Ag",
  NEW_CUSTOMER: "http://41.215.180.245:8085/channel",
  ACC_NO_VALIDATION: "^[0-9]{16,16}$",
  COUNTRY_CODE: "237",
  LOCAL_CURRENCY_CODE: "XAF",
  CHARGE_BORNE_BY: false,
  BENE_BRANCH: true,
  REMARKS_MAX: "50",
  CLIENT_NAME: "NFC",
  TRANSFER_TYPES: ["IAT"],
  SI_TRANSFER_TYPES: ["IAT"],
  CHEQUE_STATUS: ["N", "U", "S", "R"],
  LANGUAGE_LIST: ["en", "fr"],
  FORMAT_LIST: [
    { title: "Pdf", value: "PDF" },
    { title: "Excel", value: "EXCEL" },
    { title: "CSV", value: "CSV" },
  ],
  MONTHEND: true,
  LANGUAGE_SELECTION: true,
  TD_CLOSE_INSTRUCTION: true,
  TD_PAYMENT_METHOD: ["R", "M", "Q"],
  FX_DEAL_REF_NO: true,
  COORDINATES: { lat: 3.7878770016343934, lng: 11.547987994026181 },
  UNIQUE_ID_TYPE: ["PASSPORT", "NATIONALID", "VOTERID", "DRIVINGLICENCE"],
  AUTH_LAYOUT_TYPE: "STATIC", // SLIDE
  DOB_MINOR_AGE_VALIDATION: 18,
  TD_TENURE_ONLY_ONE: false,
  TD_TENURE_SELECT_ANY: true,
  TD_TENURE_DEFAULT_FROM_PRODUCT: false,
  CHEQUE_NO_LENGTH: "^[0-9]{5,10}$",
  TC_MODULE_TYPE: "CUSTOM", //GENERAL
  MIN_TRANSFER_LIMIT: 1,
  ACC_NO_LENGTH: 16,
  BENEFICIARY_TRANSFER_TABS: ["INTERNAL", "DOMESTIC", "OWN"],
  APP_ANDROID_LINK:
    "https://play.google.com/store/apps/details?id=com.techurate.nfc&hl=en_IN&gl=US",
  APP_IOS_LINK:
    "https://apps.apple.com/us/app/nfc-bank-mobilebanking/id1296784939#?platform=ipad",
  CARD_REQUEST_TYPES: ["New", "Renewal", "Replacement"],
  SAVING_ACCOUNT_TYPES: ["S"],
  CURRENT_ACCOUNT_TYPES: ["U"],
  DEPOSIT_ACCOUNT_TYPES: ["Y"],
  LOAN_ACCOUNT_TYPES: ["CL"],
  SCHEDULED_TRANSFERS: false,
  SCHEDULED_PAYMENTS: false,
  DOM_ACC_NO_LENGTH: 23,
};

const prod = {
  NEO_KEY: "20E38214tC181205",
  // SERVICE_URL: "http://uat.nfcbankonline.com:8000/apigateway",
  SERVICE_URL: "https://www.nfcbankonline.com/apigateway",
  GOOGLE_MAPS_API_KEY: "AIzaSyD94dYAJU4hkOyMi3mz6QGWxUsqkAx-9Ag",
  NEW_CUSTOMER: "http://41.215.180.245:8085/channel",
  ACC_NO_VALIDATION: "^[0-9]{16,16}$",
  COUNTRY_CODE: "237",
  LOCAL_CURRENCY_CODE: "XAF",
  CHARGE_BORNE_BY: false,
  BENE_BRANCH: true,
  REMARKS_MAX: "50",
  CLIENT_NAME: "NFC",
  TRANSFER_TYPES: ["IAT"],
  SI_TRANSFER_TYPES: ["IAT"],
  CHEQUE_STATUS: ["N", "U", "S", "R"],
  LANGUAGE_LIST: ["en", "fr"],
  MONTHEND: true,
  LANGUAGE_SELECTION: true,
  TD_CLOSE_INSTRUCTION: true,
  TD_PAYMENT_METHOD: ["R", "M", "Q"],
  FX_DEAL_REF_NO: true,
  COORDINATES: { lat: 3.7878770016343934, lng: 11.547987994026181 },
  UNIQUE_ID_TYPE: ["PASSPORT", "NATIONALID", "VOTERID", "DRIVINGLICENCE"],
  AUTH_LAYOUT_TYPE: "STATIC", // SLIDE
  DOB_MINOR_AGE_VALIDATION: 18,
  TD_TENURE_ONLY_ONE: false,
  TD_TENURE_SELECT_ANY: true,
  TD_TENURE_DEFAULT_FROM_PRODUCT: false,
  CHEQUE_NO_LENGTH: "^[0-9]{5,10}$",
  TC_MODULE_TYPE: "CUSTOM", //GENERAL
  MIN_TRANSFER_LIMIT: 1,
  ACC_NO_LENGTH: 16,
  BENEFICIARY_TRANSFER_TABS: ["INTERNAL", "DOMESTIC", "OWN"],
  APP_ANDROID_LINK:
    "https://play.google.com/store/apps/details?id=com.techurate.nfc&hl=en_IN&gl=US",
  APP_IOS_LINK:
    "https://apps.apple.com/us/app/nfc-bank-mobilebanking/id1296784939#?platform=ipad",
  CARD_REQUEST_TYPES: ["New", "Renewal", "Replacement"],
  SAVING_ACCOUNT_TYPES: ["S"],
  CURRENT_ACCOUNT_TYPES: ["U"],
  DEPOSIT_ACCOUNT_TYPES: ["Y"],
  LOAN_ACCOUNT_TYPES: ["CL"],
  SCHEDULED_TRANSFERS: false,
  SCHEDULED_PAYMENTS: false,
  DOM_ACC_NO_LENGTH: 23,
};
const config = process.env.REACT_APP_STAGE === "prod" ? prod : dev;

export default { ...config };
